import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'

export const stripTypenames = (value) => {
  if (Array.isArray(value)) {
    return value.map(stripTypenames)
  } else if (value !== null && typeof value === 'object') {
    const newObject = {}
    for (const property in value) {
      if (property !== '__typename') {
        newObject[property] = stripTypenames(value[property])
      }
    }
    return newObject
  } else {
    return value
  }
}

export const generateRandomId = (prefix) => {
  return `${Date.now()}-${Math.random()}${prefix ? `-${prefix}` : ''}`
}

export const sortWorkExperienceAndTrainingRecords = (array) => {
  const cloneArray = cloneDeep(array).map((item) => {
    if (!item.endDate) item.endDate = item.startDate
    const endDate = moment(item.endDate)
    const startDate = moment(item.startDate)
    item.endDate = new Date(endDate.year(), endDate.month())
    item.startDate = new Date(startDate.year(), startDate.month())
    return item
  })
  return cloneArray.sort((a, b) => {
    if ((a.isCurrently && b.isCurrently) || a.endDate.toDateString() === b.endDate.toDateString()) {
      return b.startDate - a.startDate
    }
    return b.endDate - a.endDate
  })
}
